import React, { Component } from "react";
import { logout } from "../actions/auth";
import CONFIG from "../config/config";

class WebSocketLogout extends Component {
  constructor(props) {
    super(props);
    this.socket = null;
  }

  getTokenFromPersist() {
    try {
      const persistRoot = JSON.parse(localStorage.getItem("persist:root"));
      const auth = JSON.parse(persistRoot.auth);
      return auth.token;
    } catch (e) {
      return null;
    }
  }

  componentDidMount() {
    this.socket = new WebSocket(
      `${CONFIG.socket_url}?token=${this.getTokenFromPersist()}`
    );

    this.socket.onopen = () => {
      console.log("[WS] Conectado al servidor WebSocket");
    };

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.action === "logout") {
        logout();
        window.location.href = "/";
      }
    };

    this.socket.onerror = (error) => {
      console.error("[WS] Error en WebSocket:", error);
    };

    // this.socket.onclose = () => {
    //   console.log("[WS] Conexión WebSocket cerrada");
    // };
  }

  componentWillUnmount() {
    if (this.socket) this.socket.close();
  }

  render() {
    return null;
  }
}

export default WebSocketLogout;
